import React, { useState } from 'react'
import Timer from '@bt-react/components/Timer'
import Countdown from '@bt-react/components/Countdown'
import ConfirmModal from '@bt-react/components/ConfirmModal'
import classnames from 'classnames'
import styles from './DeadMansHandleContent.module.scss'
import { DeadMansHandleContentProps} from './types'

const DeadMansHandleContent: React.FunctionComponent<DeadMansHandleContentProps> = props => {

  const [ dismissed, setDismissed ] = useState(false)

  const cancel = () => setDismissed(true)

  const timerClasses = classnames()

  return !dismissed ? <ConfirmModal
    content={{
      header: 'This talk is overrunning',
      body: <>
        <div data-bdd='dead-mans-handle'>
          Talk duration <Timer
            date={props.datetime}
            className={timerClasses}
          />
        </div>
        <div>
          Automatically ending in <Countdown
            date={props.gigTerminationTime}
            countdownText=''
            className={styles['dead-mans-handle-countdown']}
            allowMinus={true}
            color='orange'
          />
        </div>
        <br/>
        <p>Note: Talk cannot overrun by more than 60 minutes.</p>
      </>,
      confirm: 'Extend talk',
      cancel: 'Cancel'
    }}
    isOpen={props.isDeadMansHandleOpen}
    onConfirm={props.onConfirm}
    onCancel={cancel}
  /> : null

}

export default DeadMansHandleContent
